import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sagaMonitorApi } from '../api/sagaMonitorApi';
import type { DemoTriggerRequest } from '../types/sagaMonitor';

/**
 * POST /api/eraf/saga-monitor/demo/{sagaName} — 데모 사가 트리거 (SAGA_MONITOR_TRIGGER)
 * 성공 시 목록·요약 쿼리 무효화
 */
export function useTriggerDemoSaga() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sagaName, body }: { sagaName: string; body: DemoTriggerRequest }) =>
      sagaMonitorApi.triggerDemo(sagaName, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['saga-monitor', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['saga-monitor', 'summary'] });
    },
  });
}
